import {Language} from "modules/enums";
import {DateTime} from "luxon";

export const getTime = (time: string, t: (path: string) => string, lang = "en") => {
	const date = DateTime.fromISO(time, {zone: "America/New_York"}).setLocale(lang);
	const month = date.toFormat("LLLL");
	const dayOfMonth = date.toFormat("dd");
	const dayTime = date.toFormat("h:mm a");

	if (lang === Language.French) {
		const dayTime = date.toFormat("HH:mm");
		return `${dayOfMonth} ${month} à ${dayTime} ${t("main.ET")}`;
	}

	return `${month} ${dayOfMonth} at ${dayTime} ${t("main.ET")}`;
};
